import NextImage, {
  ImageProps as NextImageProps,
  StaticImageData,
} from 'next/image';
import { ForwardedRef, forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

export type ImageProps = NextImageProps & { ref: any };

export const Image = forwardRef(
  (props: ImageProps, ref: ForwardedRef<HTMLImageElement>) => {
    const imageStyles = '';

    const imageSrc = (props.src || {}) as StaticImageData;
    const placeholder =
      imageSrc.blurDataURL || props.blurDataURL ? 'blur' : 'empty';

    return (
      <NextImage
        placeholder={placeholder}
        {...props}
        ref={ref}
        className={twMerge(imageStyles, props.className)}
      />
    );
  },
);
